<template>
<div>
    <div class="w-400px mg-auto">
        <p class="bold dp-inblock h-30px font-23 mt-20">{{programName}} <br> 수강자 등록하기</p>
        <p class="font-13 pt-20">
            <span class="bold font-16 dp-block">신청자 정보 입력 </span>
            - 수강신청을 위한 신청자 정보를 정확히 입력해 주세요.
        </p>

        <div class="mt-30">
            <table class="clear admin-table-row mb-20 table-auto">
                <thead>
                    <tr>
                        <th class="w-150px">
                            이름 <span class="txt-red">*</span>
                        </th>
                        <td>
                            <input v-model="name" type="text" class="w-100per">
                        </td>
                    </tr>
                    <tr>
                        <th class="w-150px">
                            E-mail <span class="txt-red">*</span>
                        </th>
                        <td>
                            <input v-model="email" type="text" class="w-100per">
                        </td>
                    </tr>
                    <tr>
                        <th class="w-150px">
                            비밀번호 <span class="txt-red">*</span>
                        </th>
                        <td>
                            <input v-model="password" type="password" class="w-100per">
                            <p class="font-13 mt-10"> ※ 수강신청 내역 확인을 위해 필요합니다.</p>
                        </td>
                    </tr>
                    <tr>
                        <th class="w-150px">
                            휴대전화번호
                        </th>
                        <td>
                            <input v-model="mobileA" type="text" class="w-30per"> - <input v-model="mobileB" type="text" class="w-30per"> - <input v-model="mobileC" type="text" class="w-30per">
                        </td>
                    </tr>
                </thead>
            </table>
        </div>
    </div>
    <div class="w-100per txt-center mt-40 mb-40">
        <button class="admin-btn-default" @click="apply()">등록하기</button>
    </div>
</div>
</template>

<script>
import {
    EmptyCheck,
    EmailFormatCheck,
    PhoneFormatCheck
} from '@/utils/validation.js'
import {
    GetUrlParams
} from '@/utils/common.js'
export default {
    data: () => ({
        name: '', // 수강자 이름
        email: '', // 수강자 이메일
        password: '', // 수강자 비밀번호
        mobile: '', // 휴대전화번호

        mobileA: '', // 휴대전화번호 첫번째 자리
        mobileB: '', // 휴대전화번호 두번째 자리
        mobileC: '', // 휴대전화번호 세번째 자리

        classList: [],

        programName: '',
        programIdx: '',
        subjectIdx: '',
        pageIdx: ''
    }),

    mounted() {
        if (sessionStorage.getItem('programName')) {
            this.programName = sessionStorage.getItem('programName')
        }

        var oParams = GetUrlParams()
        if (typeof oParams.programIdx === 'undefined') {
            alert('해당 페이지는 주소창으로의 진입이 불가능합니다.')
            window.close()
        }

        console.log('oParams', oParams)
        this.subjectIdx = oParams.subjectIdx
        this.programIdx = oParams.programIdx
        var params = {
            programIdx: this.programIdx
        }

        this.axios.get(this.axios.root + this.axios.port + '/admin/user-list', {
            params: params
        }).then(res => {
            console.log('res', res)
            if (res.data.err === 0) {
                this.classList = res.data.classList
                this.pageIdx = this.classList[0].idx_itm_sugang_page_main
            } else {
                alert(res.data.result)
            }
        })

        // var subjectIdx = oParams.subjectIdx
        // var params = {
        //     subjectIdx: subjectIdx
        // }
        // this.axios.get(this.axios.root + this.axios.port + '/admin/user-list-info', {
        //     params: params
        // })
        //     .then(res => {
        //         console.log('res', res)
        //         if (res.data.err === 0) {

        //         } else {
        //             alert(res.data.result)
        //         }
        //     })
    },

    methods: {
        // 관리자가 수강자 직접 등록하기
        apply() {
            // 필수 입력란 validation 체크
            if (!EmptyCheck(this.name, '이름을')) {
                return false
            } else if (!EmptyCheck(this.email, '이메일을')) {
                return false
            } else if (!EmailFormatCheck(this.email)) {
                return false
            } else if (!EmptyCheck(this.password, '비밀번호를')) {
                return false
            }

            this.mobile = this.mobileA + '-' + this.mobileB + '-' + this.mobileC
            var tempMobile = this.mobileA + this.mobileB + this.mobileC
            // 선택 입력란 validtion 체크 
            // 휴대전화번호: 미 입력시 통과, 1개라도 입력시 번호 포맷형식 검사
            if (tempMobile.trim() !== '') {
                if (!PhoneFormatCheck(this.mobile)) {
                    return false
                }
            }

            // var params = {
            //     vo: {
            //         classList:[]
            //     },
            //     programIdx: this.programIdx
            // }

            // for (var item of this.classList) {
            //     console.log('item', item)
            //     params['vo']['classList'].push({
            //         classIdx: item.class_idx,
            //         className: item.class_name,
            //         idxItmSugangPageMain: item.idx_itm_sugang_page_main,
            //         idxItmSugangProgram: this.programIdx,
            //         subjectList: [{
            //             subjectIdx: item.subject_idx,
            //             subjectName: item.subject_name
            //         }]
            //     })
            // }

            // params['vo']['email'] = this.email
            // params['vo']['idxItmSugangPageMain'] = this.pageIdx
            // params['vo']['mobile'] = tempMobile
            // params['vo']['name'] = this.name
            // params['vo']['password'] = this.password
            // params['vo']['type'] = 'Y'

            ////////////////////////////////////////

            var param0 = {
                classList: [],
                programIdx: this.programIdx
            }

            for (var item of this.classList) {
                if (item.subject_idx === Number(this.subjectIdx)) {
                    param0['classList'].push({
                        classIdx: item.class_idx,
                        className: item.class_name,
                        idxItmSugangPageMain: item.idx_itm_sugang_page_main,
                        idxItmSugangProgram: this.programIdx,
                        subjectList: [{
                            subjectIdx: item.subject_idx,
                            subjectName: item.subject_name
                        }]
                    })
                    break
                }
            }

            param0['email'] = this.email
            param0['idxItmSugangPageMain'] = this.pageIdx
            param0['mobile'] = tempMobile
            param0['name'] = this.name
            param0['password'] = this.password

            if (this.classList.length !== 0) {
                param0['type'] = 'Y'
            } else {
                param0['type'] = 'N'
            }

            /////////////////////////////////////////

            // var params = new FormData()

            // var vo = {
            //     classList:[]
            // }

            // for (var item of this.classList) {
            //     console.log('item', item)
            //     vo['classList'].push({
            //         classIdx: item.class_idx,
            //         className: item.class_name,
            //         idxItmSugangPageMain: item.idx_itm_sugang_page_main,
            //         idxItmSugangProgram: this.programIdx,
            //         subjectList: [{
            //             subjectIdx: item.subject_idx,
            //             subjectName: item.subject_name
            //         }]
            //     })
            // }

            // vo['email'] = this.email
            // vo['idxItmSugangPageMain'] = this.pageIdx
            // vo['mobile'] = tempMobile
            // vo['name'] = this.name
            // vo['password'] = this.password
            // vo['type'] = 'Y'

            // params.append('programIdx', this.programIdx)
            // params.append('vo', vo)

            this.axios
                .post(this.axios.root + this.axios.port + "/user/check-subjectdup", param0)
                .then((res) => {
                    console.log('res 중복체크', res)
                    if (res.data.err === 0) {
                        this.axios.post(this.axios.root + this.axios.port + '/admin/user-regist', param0)
                            .then(res => {
                                console.log('res', res)
                                if (res.data.err === 0) {
                                    alert('등록되었습니다.')
                                    window.close()
                                } else {
                                    alert(res.data.result)
                                    return false
                                }
                            })
                    } else {
                        alert(res.data.result)
                        return false
                    }
                })

            // this.axios.post(this.axios.root + this.axios.port + '/admin/user-regist', params)

        }
    }
}
</script>
